import { render, staticRenderFns } from "./QuimicoFarmaceuticoView.vue?vue&type=template&id=ebf0bef4"
import script from "./QuimicoFarmaceuticoView.vue?vue&type=script&lang=js"
export * from "./QuimicoFarmaceuticoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports